export default __webpack_public_path__ + "static/media/basket.028cb6b4.svg";